import { useEffect, useState } from 'react';

export function useTypewriter({ open, text, speedMs = 16 }) {
  const [value, setValue] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!open || !text) {
      setValue('');
      setDone(false);
      return undefined;
    }

    let i = 0;
    setValue('');
    setDone(false);

    const timer = setInterval(() => {
      i += 1;
      setValue(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(timer);
        setDone(true);
      }
    }, speedMs);

    return () => clearInterval(timer);
  }, [open, speedMs, text]);

  return { value, done };
}
